<template>
  <div class="body">
    <div>
      <!--------- first-section ------->
      <div
        class="first-section"
        style="justify-content: space-between !important"
      >
        <div class="users-block">
          <div class="block__title">
            <h3>Users Overview</h3>
            <label for="time" style="margin: 0 10px  0  100px">Time</label>
            <select
              class="viewDate"
              name="time"
              @change="handleTimeSelection"
              v-model="activeUsersModel"
            >
              <option value="total">total</option>
              <option value="week">week</option>
              <option value="month">month</option>
              <option value="year">year</option>
            </select>
          </div>

          <div class="usersActiveNr">
            <img
              src="../assets/Icons/team.png"
              style="height: 20px; width: 40px"
              alt=""
            />
            <br />
            <h4>Total Number of Active Users</h4>
            <br />
            <p class="pp">All users who use Skill Court</p>
            <br />

            <span class="activeUsersNr">{{ getTotalActiveUsers }}</span>
          </div>
        </div>

        <div class="users-age-block">
          <h3>Age of Users Overview</h3>
          <div class="box" id="charAgeBar">
            <charAgeBar class="ffff" />
          </div>
        </div>
      </div>

      <!--------- second-section ------->
      <div class="second-section">
        <div class="time-block">
          <h3>Time Statistic Overview</h3>

          <div class="box">
            <!-- <div> -->
            <charBar id="char-AgeRange" style="background-color: #383838" />
            <!-- </div> -->
          </div>
        </div>

        <div class="using-skillCourt-block">
          <h3>
            Total SkillCourt single and multiplayer usage per hour of the day
          </h3>
          <div class="boxs">
            <div class="box" id="box1">
              <div id="char-line-div">
                <charline />
              </div>
            </div>
            <h3>Total single and multiplayer usage</h3>
            <div class="box" id="box2">
              <div style="background-color: #383838">
                <charPie />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="fourth-section">
        <UsersList />
      </div>
    </div>
    <!-- <div v-else>
      <div class="loader"></div>
    </div> -->
  </div>
</template>

<script>
import UsersList from "../components/users/UsersList.vue";

import charPie from "../components/users/CharUsersPie.vue";
import charBar from "../components/users/CharUsersBar.vue";
import charline from "../components/users/CharUsersLine";
import charAgeBar from "../components/users/ChartUsersAgeBar";

import { mapGetters } from "vuex";
import { GET_ACTIVE_USERS_OVERVIEW } from "../store/actions.type";
import { GET_ACTIVITY_RESULTS } from "../store/actions.type";
import { GET_SKILLGAMES_USAGE } from "../store/actions.type";
import { GET_SKILLGAMES_PERCENTAGE_USAGE } from "../store/actions.type";

export default {
  data() {
    return {
      isLoaded: false,
      activeUsersModel: "week",
      activeUsersLabel: "",
      activeUsersRate: 0
    };
  },
  components: {
    UsersList,
    charPie,
    charBar,
    charline,
    charAgeBar
  },

  async mounted() {
    this.loadQueries();
  },
  watch: {
    getSelectedCourt() {
      this.loadQueries();
    }
  },
  computed: {
    ...mapGetters([
      "getSkillgameLogs",
      "takeAllUsers",
      "take_results_by_date_arrays",
      "takeSkillgames",
      "takeAllFields",
      "takeCategories",
      "getTotalActiveUsers",
      "getSelectedCourt"
    ]),
    ...mapGetters(["getTotalActiveUsers"]),

    filterdItems() {
      if (this.sortType === "id")
        return this.items.slice(0).sort((a, b) => (a.id > b.id ? 1 : -1));
      if (this.sortType === "Booked_from ")
        return this.items
          .slice(0)
          .sort((a, b) => (a.Booked_from > b.Booked_from ? 1 : -1));
      if (this.search !== "")
        return this.items.filter(item => {
          return item.Name_of_section.match(this.search);
        });

      return this.items
        .slice(0)
        .sort((a, b) => (a.Booked_from > b.Booked_from ? 1 : -1));
    }
  },
  methods: {
    async loadQueries() {
      await this.$store.dispatch(GET_ACTIVE_USERS_OVERVIEW, {
        courtId: this.getSelectedCourt.id,
        time: this.activeUsersModel
      });

      await this.$store.dispatch(GET_ACTIVITY_RESULTS, {
        courtId: this.getSelectedCourt.id,
        time: this.activeUsersModel
      });

      await this.$store.dispatch(GET_SKILLGAMES_USAGE, {
        courtId: this.getSelectedCourt.id
      });

      await this.$store.dispatch(GET_SKILLGAMES_PERCENTAGE_USAGE, {
        courtId: this.getSelectedCourt.id
      });
    },
    async handleTimeSelection() {
      await this.$store.dispatch(GET_ACTIVE_USERS_OVERVIEW, {
        courtId: this.getSelectedCourt.id,
        time: this.activeUsersModel
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.body {
  width: 95%;
  margin: 0px auto 20px auto;
}
/* /////////////// class="first-section" /////////////// */
.first-section {
  display: flex;
  flex-direction: column;
  margin: 10px auto;
  overflow: hidden;
  align-content: space-between;
  justify-content: space-between;
  width: 92%;
}

h3 {
  margin: 39px 0 16px 0;
}
.users-age-block {
  //margin: -20px 0 0 0px;
  height: 264px;
  // height:264px
}

#charAgeBar {
  // margin: 0 0 0 5px;
  padding: 0;
  height: 248px;
  display: flex;
  flex-direction: column;
}
select {
  direction: rtl;
  /* text-align: justify !important; */
  text-align: center !important;
  text-indent: 0%;
}
option {
  direction: ltr !important;
  text-align: left;
}
// .ffff {
//   //margin: 0 50px;
// }
.box {
  background-color: #383838;
  // box-shadow: 3px 3px 10px 0 rgba(41, 41, 41, 0.6);
}
///////////////////////////
.users-block {
  display: flex;
  flex-direction: column;
}
.block__title {
  font-family: Montserrat-Regular;
  //margin: -40px 0 0 3px;
  height: 75px;
}
.usersActiveNr {
  padding: 20px 40px 20px 30px;
  font-family: Montserrat-SemiBold;
  font-weight: normal;
  width: 388px;
  height: 200px;
  background-color: #383838;
  box-shadow: 3px 3px 10px 0 rgba(41, 41, 41, 0.6);

  img {
    justify-content: flex-end;
  }

  h4 {
    margin: 16px 0 0 0;
    font-size: 18px;
  }
  .pp {
    font-size: 14px;
    opacity: 0.7;
    color: #c3c3c3;
  }
  .activeUsersNr {
    font-size: 30px;
    // width:40px;
  }
  .activeUsersRate1 {
    // margin-left: 6px;
    color: #56e656;
    font-size: 14px;
    float: right;
  }
  .activeUsersRate0 {
    // margin-left: 6px;
    color: #fd2d2d;
    font-size: 14px;
    float: right;
  }

  .lastweek {
    font-size: 14px;
  }
}

/* /////////////// class="second-section" /////////////// */
.second-section {
  display: flex;
  flex-direction: column;
  margin: 10px auto;
  overflow: hidden;
  align-content: space-between;
  justify-content: space-between;
  width: 92%;
}
.second-section h3 {
  margin: 50px 0 16px 0;
}
.time-block .box {
  width: 886px;
  height: 520px;
}
// .using-skillCourt-block {
//   //margin-left: 24px;
// }

.time-block > .box {
  width: 100%;
}

.boxs {
  display: flex;
  flex-direction: column;
}
#char-AgeRange {
  height: 100%;
  margin: 0 px 10px 0px 10px;
}

.box__header {
  width: inherit;
}

.boxs #box1 {
  height: 248px;
  margin-bottom: 10px;
}
// #char-line-div {
//   //margin: 50px 30px 0 30px;
// }

.boxs #box2 {
  height: 248px;
  background-color: #383838;
}

/* /////////////// class="thierd-section" /////////////// */
.third-section {
  display: flex;
  flex-direction: row;
  margin: 10px auto;
  overflow: hidden;
  align-content: space-between;
  justify-content: space-between;
  width: 92%;
}

@media (min-width: 576px) {
  .third-section {
    flex-flow: row wrap;
  }
  .third-section > .box {
    flex: 0.5;
  }
}

@media (min-width: 768px) {
  .third-section {
    flex-flow: row wrap;
  }
  .third-section > div {
    width: 33.33% !important;
  }
  .third-section > .box {
    order: 1;
  }
}

.thierd-section .box {
  margin-top: 50px;
}

/* /////////////// class="Fourth-block" /////////////// */
.fourth-section {
  margin: 0px auto;
  width: 97%;
}
.loader {
  border: 10px solid #f3f3f3;
  border-radius: 50%;
  border-top: 10px solid #f7941e;
  width: 120px;
  height: 120px;
  -webkit-animation: spin 2s linear infinite; /* Safari */
  animation: spin 2s linear infinite;
  margin: auto;
  position: absolute;
  top: 10%;
  left: 10%;
  bottom: 0;
  right: 0;
}
@-webkit-keyframes spin {
  0% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@media (min-width: 768px) {
  .first-section {
    flex-flow: row wrap;
  }
  .first-section > div {
    width: 100% !important;
  }
  .first-section > .user-block {
    order: 1;
  }
  .first-section > .users-age-block {
    order: 2;
  }
}
</style>
